var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "title_cont"
  }, [_c('h2', {
    staticClass: "title_txt"
  }, [_vm._v("마이페이지")]), _c('ul', {
    staticClass: "protocol_search_tab"
  }, [_vm._l(_vm.links, function (item, i) {
    return [_c('li', {
      key: i,
      class: [item.onUrlList.includes(_vm.$route.path) ? 'on' : ''],
      on: {
        "click": function ($event) {
          _vm.showLnb = item;
        },
        "mouseenter": function ($event) {
          _vm.showLnb = item;
        },
        "mouseover": function ($event) {
          _vm.showLnb = item;
        },
        "mouseleave": function ($event) {
          _vm.showLnb = null;
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: `${item.url}`,
          query: item.query
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1)];
  })], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }